(() => {
  const ROOT_SELECTOR = '.hot-products-carousel';
  const SWIPER_SELECTOR = '.hot-products-carousel__swiper';

  function getActiveSlide(root, swiper) {
    const active = root.querySelector(`${SWIPER_SELECTOR} .swiper-slide-active`);
    if (active) return active;

    if (!swiper) return null;

    const realSlides = root.querySelectorAll(
      `${SWIPER_SELECTOR} .swiper-slide:not(.swiper-slide-duplicate)`
    );
    const index = swiper.params.loop ? swiper.realIndex : swiper.activeIndex;
    return realSlides[index] || realSlides[0] || null;
  }

  function updateActiveInfo(root, swiper) {
    const target = root.querySelector('[data-info-target]');
    if (!target) return;

    const activeSlide = getActiveSlide(root, swiper);
    if (!activeSlide) {
      target.innerHTML = '';
      return;
    }

    const template = activeSlide.querySelector('template.hot-products-carousel__info-template');
    if (!template) {
      target.innerHTML = '';
      return;
    }

    const content = template.content.cloneNode(true);
    target.replaceChildren(content);

    const hint = root.querySelector('[data-editor-hint]');
    if (hint) {
      const missingProduct = activeSlide.dataset.hasProduct !== 'true';
      hint.hidden = !missingProduct;
    }
  }

  function toggleNavigation(root, slideCount, swiper) {
    const prev = root.querySelector('.hot-products-carousel__nav--prev');
    const next = root.querySelector('.hot-products-carousel__nav--next');
    const showNav = slideCount > 3;
    const isLoop = swiper && swiper.params && swiper.params.loop;

    if (prev) prev.hidden = !showNav;
    if (next) next.hidden = !showNav;

    if (!swiper || !showNav) return;

    if (isLoop) {
      if (prev) {
        prev.disabled = false;
        prev.classList.remove('swiper-button-disabled');
      }
      if (next) {
        next.disabled = false;
        next.classList.remove('swiper-button-disabled');
      }
      return;
    }

    if (prev) {
      prev.disabled = swiper.isBeginning;
      prev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
    }

    if (next) {
      next.disabled = swiper.isEnd;
      next.classList.toggle('swiper-button-disabled', swiper.isEnd);
    }
  }

  function bindProductLinks(root, swiper) {
    root.querySelectorAll('.hot-products-carousel__link').forEach((link) => {
      link.addEventListener('click', (event) => {
        const slide = link.closest('.swiper-slide');
        if (!slide || !swiper) return;

        if (!slide.classList.contains('swiper-slide-active')) {
          event.preventDefault();

          const index = parseInt(slide.dataset.slideIndex || '0', 10);
          if (Number.isNaN(index)) return;

          if (swiper.params.loop) {
            swiper.slideToLoop(index);
          } else {
            swiper.slideTo(index);
          }
        }
      });
    });
  }

  function destroySwiper(root) {
    if (root._hotProductsSwiper && root._hotProductsSwiper.destroy) {
      root._hotProductsSwiper.destroy(true, true);
    }
    root._hotProductsSwiper = null;
  }

  function initSwiper(root) {
    const container = root.querySelector(SWIPER_SELECTOR);
    if (!container) return null;

    const slideCount = parseInt(root.dataset.slideCount || '0', 10);
    const prevEl = root.querySelector('.hot-products-carousel__nav--prev');
    const nextEl = root.querySelector('.hot-products-carousel__nav--next');
    const enableLoop = slideCount >= 3;

    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded');
      updateActiveInfo(root, null);
      return null;
    }

    const swiper = new Swiper(container, {
      slidesPerView: 1.6,
      centeredSlides: true,
      spaceBetween: 8,
      slidesPerGroup: 1,
      slideToClickedSlide: true,
      watchOverflow: true,
      loop: enableLoop,
      loopAdditionalSlides: enableLoop ? 2 : 0,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : {},
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      on: {
        init(swiperInstance) {
          updateActiveInfo(root, swiperInstance);
          toggleNavigation(root, slideCount, swiperInstance);
        },
        slideChange(swiperInstance) {
          updateActiveInfo(root, swiperInstance);
        },
        slideChangeTransitionEnd(swiperInstance) {
          updateActiveInfo(root, swiperInstance);
          toggleNavigation(root, slideCount, swiperInstance);
        },
        reachBeginning(swiperInstance) {
          toggleNavigation(root, slideCount, swiperInstance);
        },
        reachEnd(swiperInstance) {
          toggleNavigation(root, slideCount, swiperInstance);
        },
        fromEdge(swiperInstance) {
          toggleNavigation(root, slideCount, swiperInstance);
        },
      },
    });

    bindProductLinks(root, swiper);
    root._hotProductsSwiper = swiper;
    return swiper;
  }

  function init(root) {
    if (!root || root.dataset.hotProductsInit === 'true') return;

    destroySwiper(root);
    initSwiper(root);
    root.classList.add('hot-products-carousel--initialized');
    root.dataset.hotProductsInit = 'true';
  }

  function teardown(root) {
    if (!root) return;
    destroySwiper(root);
    delete root.dataset.hotProductsInit;
    root.classList.remove('hot-products-carousel--initialized');
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (root) {
      teardown(root);
      init(root);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (root) teardown(root);
  });
})();
